// @ts-nocheck
import React from 'react';

interface FormFieldProps {
  id: string;
  label: string;
  children: React.ReactNode;
  labelStyle?: React.CSSProperties;
  className?: string;
  required?: boolean;
}

/**
 * Reusable form field component with consistent styling
 */
const FormField: React.FC<FormFieldProps> = ({ 
  id, 
  label, 
  children, 
  labelStyle,
  className = "",
  required = false
}) => {
  return (
    <div className={`${className}`}>
      <label htmlFor={id} className="block text-sm font-medium mb-1" style={labelStyle}>
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      {children}
    </div>
  );
};

export default FormField;